{
  "Menus": [
    {
      "displayName": "HOME",
      "url": "/home",
      "order": 0,
      "id": 1,
      "parentId": 0,
      "disable": false
    },
    {
      "displayName": "USERS",
      "url": "/users",
      "order": 1,
      "id": 3,
      "parentId": 0,
      "disable": false
    },
    {
      "displayName": "HAVEN ACTIVITY LOG",
      "url": "/user-activities",
      "order": 2,
      "id": 4,
      "parentId": 0,
      "disable": false
    }
  ]
}